import { render, staticRenderFns } from "./VideoForm.vue?vue&type=template&id=85e7b88a&scoped=true"
import script from "./VideoForm.vue?vue&type=script&lang=js"
export * from "./VideoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e7b88a",
  null
  
)

export default component.exports